/* eslint-disable react/no-deprecated */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import {
    Paper,
    Title,
    TableFooter,
    Modal,
    Switch,
    DriverModal,
    EmptyView,
    Table,
    BottomNavigationIcon
} from '../../components';
import { checkAccess } from '../../utils/admins';
import {
    handleDriversData,
    handleSubmit,
    onChangeData,
    showDriversTypeButton,
    switchDriverActivation,
    handleChange,
    getBottomNavigationIcon,
    handleCloseModal,
    defineDriversTableHeads
} from './Drivers.services';
import { displayPriceFormat } from '../../utils/tools';
import { styles } from './Drivers.styles';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/driver.svg';
import {
    EMPTY_DESIGN_DRIVER_TEXT,
    EMPTY_DESIGN_DRIVER_TITLE,
    EMPTY_DESIGN_FREELANCE_DRIVER_TEXT,
    EMPTY_DESIGN_FREELANCE_DRIVER_TITLE
} from '../../constants/dishopInfo';
import { clearDriversInterval, fetchAllDrivers } from '../../apis/firebase'
import { DRIVERS_PULL_INTERVAL } from '../../constants'
import { isFreelanceEnabled } from 'src/utils/delivery';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { ExtendedDriverList, ExtendedDriverData } from 'src/models/drivers/driver';
import { showHelpModal } from 'src/actions';
import moment from 'moment';

export type DriversViewState = {
    showModalUpdateDriver: boolean;
    modalOpen: boolean;
    searchTerm: string;
    isLoading: boolean;
    listButton: string[];
    selectedTab: number;
    currentDrivers: ExtendedDriverList;
}

function Drivers({ classes }) {
    const dispatch = useAppDispatch();
    const { drivers, independentDrivers } = useAppSelector(state => state.firebaseRealTime);
    const { shopId, address, isAllShops } = useAppSelector(state => state.user);
    const [selectedDriver, setSelectedDriver] = useState<ExtendedDriverData | null>(null)
    const [componentState, setComponentState] = useState<DriversViewState>({
        showModalUpdateDriver: false,
        modalOpen: false,
        searchTerm: '',
        isLoading: true,
        listButton: [],
        selectedTab: 0,
        currentDrivers: [],
    })
    useEffect(() => {
        showDriversTypeButton(setComponentState, shopId)
        fetchAllDrivers(DRIVERS_PULL_INTERVAL, shopId);
    }, [shopId])
    const { location } = address
    useEffect(() => {
        if (!isAllShops) {
            handleDriversData(drivers, independentDrivers, componentState.selectedTab, setComponentState, { location, shopId });
        }
        else clearDriversInterval();
    }, [drivers, independentDrivers, componentState.selectedTab, shopId, address, isAllShops])

    const isIndependentTab = componentState.selectedTab === 1;
    const canToggleDrivers = checkAccess('features', 'canToggleFreelanceDrivers') || (!isIndependentTab && checkAccess('features', 'canToggleEmployeeDrivers'));

    const createTableRow = (driversCollection: ExtendedDriverList) => {
        return (
            <TableBody>
                {_.map(driversCollection, (driver: ExtendedDriverData) => {
                    return (
                        <TableRow
                            key={driver.id}
                            onClick={() => {
                                setSelectedDriver(driver);
                                setComponentState(prevState => ({ ...prevState, modalOpen: true }));
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <TableCell align='center' className={classes.tableRow}>
                                {driver.firstName} {driver.lastName || ''}
                            </TableCell>
                            <TableCell align='center' className={classes.tableRow}>
                                {driver.numero || ''}
                            </TableCell>
                            <TableCell align='center' className={classes.tableRow}>
                                {driver.onTransaction}
                            </TableCell>
                            <TableCell align='center' className={classes.tableRow}>
                                {driver.nbOrderSuccess}
                            </TableCell>
                            {!isIndependentTab && (
                                <>
                                    <TableCell align='center' className={classes.tableRow}>
                                        <p className={classes.typo}>{`Espèces: ${displayPriceFormat(driver?.cash || 0)}`}</p>
                                        <p className={`mt-1 ${classes.typo}`}>{`Tickets resto: ${displayPriceFormat(driver?.ticket_resto || 0)}`}</p>
                                        <p className={`mt-1 ${classes.typo}`}>{`TPE: ${displayPriceFormat(driver?.cb || 0)}`}</p>
                                    </TableCell>
                                </>
                            )}
                            <TableCell align="center" className={classes.tableRow}>
                                {driver?.creationTime ? moment(driver?.creationTime).locale('fr').format('DD MMMM YYYY') : '--'}
                            </TableCell>
                            {canToggleDrivers && (
                                <TableCell align='center' className='p-0'>
                                    <Switch
                                        checked={driver.enabled}
                                        onClick={(e: React.MouseEvent<HTMLInputElement>) => e.stopPropagation()}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                            switchDriverActivation(driver.id, shopId, isIndependentTab, e.target.checked, componentState.currentDrivers, setComponentState)
                                        }
                                        inputProps={{
                                            'aria-label': 'primary checkbox'
                                        }}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                    );
                })}
            </TableBody>
        );
    };

    const iconList = getBottomNavigationIcon(componentState.listButton);
    const bottomNavigationClassName = iconList.length > 1 ? 'col-sm-6 col-md-5 col-lg-4 col-xl-3' : 'col-sm-4 col-md-3 col-lg-2';

    return (
        <div className='px-4 pb-4'>
            <Title title='Livreurs' onClick={() => dispatch(showHelpModal('livreurs'))} />
            <div className='row'>
                <div className={`col-12 ${bottomNavigationClassName} text-nowrap`}>
                    <Paper scrollOption='auto'>
                        <BottomNavigationIcon
                            value={componentState.selectedTab}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>, newValue: number) =>
                                onChangeData(event, newValue, independentDrivers, drivers, setComponentState, dispatch, { location, shopId })}
                            selectedTab={componentState.selectedTab}
                            collection={iconList}
                        />
                    </Paper>
                </div>
            </div>
            {(!(_.size(componentState.currentDrivers) > 0) || (isIndependentTab && !isFreelanceEnabled(shopId))) ? (
                <EmptyView
                    className={classes.svg}
                    src={ImportedSVG}
                    title={isIndependentTab ?
                        EMPTY_DESIGN_FREELANCE_DRIVER_TITLE : EMPTY_DESIGN_DRIVER_TITLE
                    }
                    isLoading={componentState.isLoading}
                    text={isIndependentTab ?
                        EMPTY_DESIGN_FREELANCE_DRIVER_TEXT : EMPTY_DESIGN_DRIVER_TEXT
                    }
                />
            ) : (
                <>
                    <div className='py-3'>
                        <Paper scrollOption='auto'>
                            <Table
                                headCells={defineDriversTableHeads(isIndependentTab, canToggleDrivers)}
                                classes={classes}
                                bodyRows={componentState.currentDrivers}
                                createTableRow={(rows: ExtendedDriverList) => createTableRow(rows)}
                                order='asc'
                                orderBy='firstName'
                            />
                            <Modal
                                color='secondary'
                                title={`Détails du livreur  `}
                                header
                                fixed
                                size='md'
                                width='600px'
                                showCancelBtn={!isIndependentTab}
                                btnTxt={isIndependentTab ? 'Retour' : 'Enregistrer'}
                                btnColor={isIndependentTab ? 'secondary' : 'primary'}
                                onClick={() => {
                                    if (isIndependentTab) {
                                        handleCloseModal(setComponentState);
                                    } else {
                                        handleSubmit(selectedDriver as ExtendedDriverData, componentState.currentDrivers, setComponentState);
                                    }
                                }}
                                handleClose={() => handleCloseModal(setComponentState)}
                                isOpen={componentState.modalOpen}
                            >
                                <DriverModal
                                    driver={selectedDriver as ExtendedDriverData}
                                    isIndependentTab={isIndependentTab}
                                    changeCollection={e => handleChange(e, setSelectedDriver)}
                                />
                            </Modal>
                        </Paper>
                    </div>
                    <TableFooter lengthOption={_.keys(componentState.currentDrivers).length} />
                </>
            )}
        </div>
    );
}

export default (withStyles(styles)(Drivers));